import { render, staticRenderFns } from "./RegistrationList.vue?vue&type=template&id=4fb2682d&scoped=true"
import script from "./RegistrationList.vue?vue&type=script&lang=js"
export * from "./RegistrationList.vue?vue&type=script&lang=js"
import style0 from "./RegistrationList.vue?vue&type=style&index=0&id=4fb2682d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fb2682d",
  null
  
)

export default component.exports